import { render, staticRenderFns } from "./AutoNegativo2leilao.vue?vue&type=template&id=0d4c6f96"
import script from "./AutoNegativo2leilao.vue?vue&type=script&lang=js"
export * from "./AutoNegativo2leilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports